import React from "react"
import { IDate } from "../../models"
import moment from "moment"
import { IconButton, FontIcon } from "material-ui"
import { blueGrey500 } from "material-ui/styles/colors"
import strings from "../../localization/strings"
import FinddDatePicker from "./FinddDatePicker"
interface IProps {
    selectedDay: IDate
    handleChange(selectedDay: IDate): void
    limitMaxDay?: IDate
}
interface IState {

}

export default class DaySelect extends React.Component<IProps, IState> {
    private FinddDatePicker
    constructor(props: IProps) {
        super(props)
    }


    render() {
        const disableNextArrow = this.props.limitMaxDay ? moment(this.props.limitMaxDay).isSame(this.props.selectedDay, "day") : false
        return (
            <div style={{ width: 300, display: "flex" }}>
                <i
                    className="fa fa-arrow-circle-left TimeActionBarArrow"
                    style={{ marginTop: 13 }}
                    onClick={() => this.props.handleChange(moment(this.props.selectedDay).subtract(1, "day"))}
                />
                <div id="TimeActionBarDate" style={{ fontSize: 15, marginLeft: 5, marginRight: 5, display: "inline-block", width: 275, textAlign: "center" }}>
                    <div style={{ fontSize: 22, fontWeight: 500 }}>
                        {moment().isSame(this.props.selectedDay, "day") ? strings.Today : moment(this.props.selectedDay).format("dddd")}
                    </div>
                    <div style={{ marginTop: 3 }}>{moment(this.props.selectedDay).format("MMMM Do YYYY")}</div>
                </div>
                <i
                    className={`fa fa-arrow-circle-right ${disableNextArrow ? "" : "TimeActionBarArrow"}`}
                    style={{ marginTop: 13, color: disableNextArrow && "#aaaaaa" }}
                    onClick={() => !disableNextArrow && this.props.handleChange(moment(this.props.selectedDay).add(1, "day"))}
                />
                <IconButton
                    style={{ marginTop: -7 }}
                    data-intercom-target={"CalendarFilter-Btn-OpenDatePicker"}
                    onTouchTap={() => this.FinddDatePicker.DatePicker.openDialog()}
                    tooltip={"Pick a date"}
                >
                    <FontIcon className={"fa fa-calendar"} />
                </IconButton>
                <div>
                    <FinddDatePicker
                        ref={(elem) => (this.FinddDatePicker = elem)}
                        id={"day-select-field"}
                        textFieldStyle={{ display: "none" }}
                        value={moment(this.props.selectedDay).toDate()}
                        onChange={(_, date: Date) => this.props.handleChange(date)}
                        cancelLabel={<span style={{ color: blueGrey500 }}>{strings.Cancel}</span>}
                        firstDayOfWeek={0}
                        maxDate={this.props.limitMaxDay && moment(this.props.limitMaxDay).toDate()}
                    />
                </div>
            </div>
        )
    }

}